import { useFetch } from "../../../_hooks/use-fetch";
import { ICreatePaymentPostRequest, ICreatePaymentPostResponse, IPaymentMethodGetResponse, IPaymentProcessGetResponse } from "./types";

export const useSubscriptionApi = () => {
  const fetch = useFetch();

  return {
    getPaymentMethods: async (): Promise<IPaymentMethodGetResponse[]> => {
      return await fetch(
        `${process.env.REACT_APP_API_PAYMENT_SERVICE}/payment-service/v1/chain`,
        "GET"
      );
    },

    createPaymentProcess: async (body: ICreatePaymentPostRequest): Promise<ICreatePaymentPostResponse> => {
      return await fetch(
        `${process.env.REACT_APP_API_PAYMENT_SERVICE}/payment-service/v1/subscription/payment`,
        "POST",
        body
      );
    },

    deletePaymentProcess: async (): Promise<undefined> => {
      return await fetch(
        `${process.env.REACT_APP_API_PAYMENT_SERVICE}/payment-service/v1/subscription/payment`,
        "DELETE"
      );
    },

    getPaymentProcess: async (): Promise<IPaymentProcessGetResponse> => {
      return await fetch(
        `${process.env.REACT_APP_API_PAYMENT_SERVICE}/payment-service/v1/subscription/payment`,
        "GET"
      );
    },
  };
};
